import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

import Home from '@/components/home.vue';
import Contact from '@/components/contact.vue';
import Login from '@/components/login.vue';
import Docs from '@/components/docs.vue';
import Register from '@/components/registerUser.vue';
import ForgotPassword from '@/components/forgotPassword.vue';
import ResetPassword from '@/components/resetPassword.vue';

import AddUser from '@/components/settings/admin/addUser.vue';
import ListUsers from '@/components/settings/admin/listUsers.vue';
import ManagePaths from '@/components/settings/admin/authorizations.vue';
import ContactPage from '@/components/settings/admin/contactPage.vue';

import UserCredentials from '@/components/settings/credential.vue';
import EditUser from '@/components/settings/admin/editUser.vue';
import ContentManagement from '@/components/settings/admin/contentManager.vue';

import AdminPost from '@/components/settings/admin/posts.vue';
import EditPost from '@/components/settings/admin/editPost.vue';
import EditImage from '@/components/contentManager/imageEditor.vue';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     if (to.hash) {
    //       console.log(to.hash);
    //       resolve({ selector: to.hash });
    //     } else if (savedPosition) {
    //       resolve(savedPosition);
    //     } else {
    //       resolve({ x: 0, y: 0 });
    //     }
    //   }, 500);
    // });
    if (to.hash) {
      console.log(to.hash);
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: (to: any, from: any) => {
          return 'Home';
        },
      },
      component: Home,
    },
    {
      path: '/contact',
      name: 'Contact',
      meta: {
        title: (to: any, from: any) => {
          return 'Contact';
        },
      },
      component: Contact,
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: (to: any, from: any) => {
          return 'Login';
        },
      },
      component: Login,
    },
    {
      path: '/register/:token',
      name: 'Register',
      meta: {
        title: (to: any, from: any) => {
          return 'Register';
        },
      },
      component: Register,
    },
    {
      path: '/forgotPassword',
      name: 'forgot password',
      meta: {
        title: (to: any, from: any) => {
          return 'Send reset password email';
        },
      },
      component: ForgotPassword,
    },
    {
      path: '/resetPassword/:token',
      name: 'Reset password password',
      meta: {
        title: (to: any, from: any) => {
          return 'Reset your password';
        },
      },
      component: ResetPassword,
    },
    {
      path: '/docs',
      name: 'Docs',
      meta: {
        title: (to: any, from: any) => {
          return 'Docs';
        },
      },
      component: Docs,
    },
    {
      path: '/docs/:path*',
      name: 'Docs with path',
      meta: {
        title: (to: any, from: any) => {
          return 'Docs';
        },
      },
      component: Docs,
    },
    {
      path: '/settings/credential',
      name: 'User settings',
      meta: {
        title: (to: any, from: any) => {
          return 'User settings';
        },
      },
      component: UserCredentials,
    },
    {
      path: '/settings/addUser',
      name: 'Manage users',
      meta: {
        title: (to: any, from: any) => {
          return 'Manage users';
        },
      },
      component: AddUser,
    },
    {
      path: '/settings/listUser',
      name: 'User List',
      meta: {
        title: (to: any, from: any) => {
          return 'User List';
        },
      },
      component: ListUsers,
    },
    {
      path: '/settings/managePaths',
      name: 'Manage restricted areas',
      meta: {
        title: (to: any, from: any) => {
          return 'Manage restricted areas';
        },
      },
      component: ManagePaths,
    },
    {
      path: '/settings/contactPageManagement',
      name: 'Manage files of the contact page',
      meta: {
        title: (to: any, from: any) => {
          return 'Manage files of the contact page';
        },
      },
      component: ContactPage,
    },
    {
      path: '/settings/contentManagement',
      name: 'Content settings',
      meta: {
        title: (to: any, from: any) => {
          return 'Content settings';
        },
      },
      component: ContentManagement,
    },
    {
      path: '/settings/postManagement',
      name: 'Manage posts',
      meta: {
        title: (to: any, from: any) => {
          return 'Manage posts';
        },
      },
      component: AdminPost,
    },
    {
      path: '/settings/*',
      redirect: '/settings/credential',
    },
    {
      path: '/editUser/:userID',
      name: 'User Editing',
      meta: {
        title: (to: any, from: any) => {
          return 'Edit User';
        },
      },
      component: EditUser,
    },
    {
      path: '/editPost/:id',
      name: 'Post Editing',
      meta: {
        title: (to: any, from: any) => {
          return 'Post Editing';
        },
      },
      component: EditPost,
    },
    {
      path: '/editImage/:id',
      name: 'Image Editing',
      meta: {
        title: (to: any, from: any) => {
          return 'Image Editing';
        },
      },
      component: EditImage,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
